import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import EditableProMode from 'components/Editor/cource/layout/controls/ElementControls/EditableProMode'
import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import GroupingDemo from './GroupingDemo'
import GroupingElement from './GroupingElement'
import GroupingFormBrand from './GroupingFormBrand'
import { STYLE_FORM_SCHEMA } from './GroupingFormStyle'
import GroupingFormValue from './GroupingFormValue'
import groupingIcon from './assets/grouping.svg'

export default genElementConfig(CONFIG_ELEMENTS.grouping, {
  label: t('elements.grouping.label'),
  icon: groupingIcon,
  group: ElementGroup.interactive,
  styleFields: STYLE_FORM_SCHEMA,
  Element: GroupingElement,
  Demo: [GroupingDemo],
  FormValue: GroupingFormValue,
  FormBrand: GroupingFormBrand,
  EditorActions: EditableProMode,
})
